import { Dialog } from "primereact/dialog";
import { IUserMast } from "../../models/UserMast";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Fetch } from "../../shared/Fetch";
import { set } from "date-fns";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    singleData: IUserMast,
}

export interface ILeads {
    team_Lead?: number,
    resource_Manager?: number,
    head?: number,
}

const schema = yup.object({
    team_Lead: yup.number().required("Team Lead is required*"),
    resource_Manager: yup.number().nullable(),
    head: yup.number().required("Head is required*"),
});

export const Leads = (props: IProps) => {
    const [teamLeads, setTeamLeads] = useState<Array<IUserMast>>([]);
    const [resourceManager, setResourceManager] = useState<Array<IUserMast>>([]);
    const [head, setHead] = useState<Array<IUserMast>>([]);
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILeads>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    function onSubmit(data: ILeads) {
        saveToDB(data);
    };

    const saveToDB = async (data: ILeads) => {
        let newData: any = data;
        newData.login_ID = props.singleData.login_ID;
        const response = await Fetch("User_Mast/updateLeads", "PUT", newData, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Leads Updated Successfully", life: 3000 });
            props.setReload(!props.reload);
            onHide();
        } else props.toast.current.show({ severity: 'error', detail: "Something went wrong", life: 3000 });
    };

    const loadTeamLead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=teamLead&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setTeamLeads(prev => prev = data);
            if (props.open && props.singleData?.team_Lead != null && data.length > 0) {
                setValue("team_Lead", props.singleData.team_Lead);
            }
        }
    };
    const loadResourceManager = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=resourceManager&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setResourceManager(prev => prev = data);
            if (props.open && props.singleData?.resource_Manager != null && data.length > 0) {
                setValue("resource_Manager", props.singleData.resource_Manager);
            }
        }
    };
    const loadHead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=head&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setHead(prev => prev = data);
            if (props.open && props.singleData?.head != null && data.length > 0) {
                setValue("head", props.singleData.head);
            }
        }
    };

    const onHide = () => {
        reset({});
        props.hideDialog();
    };
    useEffect(() => {
        if (props.open) {
            loadTeamLead();
            loadResourceManager();
            loadHead();
        }
    }, [props.open]);

    useEffect(() => {
    }, [teamLeads, resourceManager, head, props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit User Leads" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdown required filter label="Team Lead" control={control} name="team_Lead" error={errors.team_Lead?.message} options={teamLeads} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Team Lead" />
                    <JVDropdown filter label="Resource Manager" control={control} name="resource_Manager" error={errors.resource_Manager?.message} options={resourceManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Resource Manager" />
                    <JVDropdown required filter label="Head" control={control} name="head" error={errors.head?.message} options={head} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Head" />
                    {/* <JVInput label="YahooID" control={control} name="user_YahooID" error={errors.user_YahooID?.message} /> */}
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}